// @flow

import { type Checkbox, type ChatFeedbackType } from '@chatchamp/chatchamp-types'

import { logger } from '../../common'

function sanitizeString (text: string): string {
  return text?.replace(/\0/g, '')
}

export function generatePayload (params: Object = {}): string {
  return JSON.stringify({
    user: window.bubbleStore.state.subscriberId,
    customer: window.bubbleStore.state.customerId,
    referrer: sanitizeString(window.bubbleStore.state.parentUrl),
    userAgent: sanitizeString(window?.navigator?.userAgent),
    ...params
  })
}

const doSend = (fn: Function) => {
  return window.websocketReadyPromise.then(() => fn())
}

export const sendRestartMessage = (chatbotPayload: ?string = null): any => {
  logger.info(`Sending restart message (Payload: ${chatbotPayload || ''})...`)
  const payload = generatePayload({
    type: 'repeat',
    ...(chatbotPayload && { chatbotPayload: chatbotPayload })
  })

  return doSend(() => window.ws.send(payload))
}

export const sendWelcomeMessageClicked = (growthToolId: ?number = null, chatbotPayload: ?string = null): any => {
  logger.info(`Sending welcome_message event with id ${growthToolId || ''}...`)
  const payload = generatePayload({
    type: 'welcome_message',
    ...(growthToolId && { growthToolId: growthToolId }),
    // $FlowFixMe
    ...(chatbotPayload && { chatbotPayload: chatbotPayload })
  })

  return doSend(() => window.ws.send(payload))
}

export const sendAutostartMessage = (chatbotPayload: ?string = null): any => {
  const payload = generatePayload({
    type: 'autostart',
    ...(chatbotPayload && { chatbotPayload: chatbotPayload })
  })

  return doSend(() => window.ws.send(payload))
}

export const sendClickedMessage = (growthToolId: ?number = null, chatbotPayload: ?string = null): any => {
  const payload = generatePayload({
    type: 'clicked',
    ...(growthToolId && { growthToolId: growthToolId }),
    // $FlowFixMe
    ...(chatbotPayload && { chatbotPayload: chatbotPayload })
  })

  return doSend(() => window.ws.send(payload))
}

export const sendLoadedMessage = (): any => {
  logger.info('Sending loaded message...')
  const payload = generatePayload({ type: 'loaded' })

  return doSend(() => window.ws.send(payload))
}

export const requestMessageHistory = (): any => {
  logger.info('Sending identity message...')
  const payload = generatePayload({ type: 'identity' })

  return doSend(() => window.ws.send(payload))
}

export const sendTextMessage = (text: string, messageId: number, streamType: boolean = false): any => {
  const payload = generatePayload({
    type: 'message',
    text,
    messageId,
    streamType
  })

  return doSend(() => window.ws.send(payload))
}

export function sendPayloadButton (buttonPayload: string, buttonTitle: string, messageId: string): any {
  const payload = generatePayload({
    type: 'postback',
    payload: buttonPayload,
    // TODO; quickReply is backwards-compatibility; Dominik; 24.03.2021
    quickReply: buttonPayload,
    quickReplyTitle: buttonTitle,
    messageId: messageId
  })

  return doSend(() => window.ws.send(payload))
}

export const sendExitButton = (text: string, messageId?: number): any => {
  const payload = generatePayload({
    type: 'exit',
    messageId,
    text
  })

  return doSend(() => window.ws.send(payload))
}

export const sendFeedbackButton = (text: string, messageId?: number, sentiment: ChatFeedbackType): any => {
  const payload = generatePayload({
    type: 'feedback',
    messageId,
    text,
    sentiment
  })

  return doSend(() => window.ws.send(payload))
}

export function sendCheckboxes (checkboxes: Array<Checkbox>, messageId: string): any {
  const payload = generatePayload({
    type: 'checkbox',
    checkboxes: checkboxes,
    messageId: messageId
  })

  return doSend(() => window.ws.send(payload))
}

export const sendMoreProductsMessage = (params: Object): any => {
  const payload = generatePayload({
    type: 'more_products',
    ...params
  })

  return doSend(() => window.ws.send(payload))
}

export function sendUploadedFile (fileUrl: string, buttonTitle: string, messageId: string): any {
  const payload = generatePayload({
    type: 'upload',
    fileUrl,
    buttonTitle,
    messageId: messageId
  })

  return doSend(() => window.ws.send(payload))
}
